import { tabTemplate } from '@/layout/state/state';
import NotFound from '@/components/errors/NotFound';

export default tabTemplate('notfound', NotFound);
